export const api = {
  walletAdjustmentList: '/ewallet/adjustment',
  loadWalletAdjustment: '/ewallet/adjustment/details',
  createWalletAdjustment: '/ewallet/adjustment/create',
  giroPaymentHistory: '/ewallet/bank-payment-history',
  giroPaymentDetail: '/ewallet/bank-payment',
  giroPaymentGenerate: '/ewallet/generate-bank-payment',
  giroRejectedPaymentList: '/ewallet/rejected-payment',
  giroRejectedPaymentUploadExcel: '/ewallet/upload-rejected-payment-file',
  giroRejectedPaymentSubmit: '/ewallet/submit-rejected-payment-records',
  submitGiroRejectedLevelOne: '/ewallet/rejected-payment-level-one',
  submitGiroRejectedLevelTwo: '/ewallet/rejected-payment-level-two',
  getGiroRejectedTemplate: '/ewallet/get-rejected-payment-sample-file',
  eWalletNewTransaction: '/ewallet/new-transaction',
  eWalletTransaction: '/ewallet/transaction',
  eWalletSearchByPin: '/ewallet/search-ewallet',
  eWalletMobileConfig: '/ewallet/mobile-config',
}
